var map = {
	"./AmericanExpress.svg": "8347",
	"./DinersClub.svg": "6758",
	"./Discover.svg": "67ad",
	"./Maestro.svg": "52c3",
	"./MasterCard.svg": "7f30",
	"./Visa.svg": "8485"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | issuers */ "issuers").then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "028f";
module.exports = webpackAsyncContext;